<div class="grid-x" [formGroup]="form">
  @if (!isCalculating) {
    <div class="cell large-12 medium-12 small-12">
      <payment-display [payments]="fees"></payment-display>
    </div>
  } @else {
    <div class="cell large-12 medium-12 small-12">
      <text-loader [run]="true" [tickType]="'.'" [interval]="1000" [text]="'Calculating Fees Due'"></text-loader>
    </div>
  }
  <ng-container>
    <div class="cell small-2 medium-2 large-2 text-align-right padding-right bold">
      Select Payment<span [ngClass]="{ 'red': form?.get('paymentType')?.invalid }">*</span>:
    </div>
    <div class="cell small-3 medium-3 large-3">
      <select formControlName="paymentType">
        @for (type of paymentTypes; track type) {
          <option [value]="type.value">{{type.name}}</option>
        }
      </select>
    </div>
    <div class="cell small-7 medium-7 large-7 padding-left">
      <button class="button" (click)="submitPaymentType()" [disabled]="form?.get('paymentType')?.value == '' || form.get('paymentType')?.disabled" >Submit Payment Type</button>
    </div>
  </ng-container>
  @if (showInvoice) {
    <invoice [paymentType]="selectedPayment" [fees]="fees" [config]="config" [documentId]="existingDocumentId" [authorization]="authorization" (newResponseReceived)="saveNewResponse($event)" (receiptIssued)="onReceiptIssued($event)"></invoice>
  }

</div>

